import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BsPlus } from "react-icons/bs";
import { BiCopy } from "react-icons/bi";
import {
  copySlide,
  createSlide,
  setCurrentCanvas,
  setCurrentSlide,
  setUpdatedCanvas,
  setIsDrawingMode
} from "../../slices/creatorSlice";
import { Tooltip } from "antd";
const Slidebar = ({ canvas }) => {
  const _Canvases = useSelector((state) => state.creator.canvases);
  const isDrawingMode = useSelector((state) => state.creator.isDrawingMode);
  const _currentSlide = useSelector((state) => state.creator.currentSlide);
  const dispatch = useDispatch();
  const handlePlusIconClick = () => {
    dispatch(createSlide());
  };
  const handleCopyIconClick = () => {
    const updatedCanvasData = canvas.toDatalessJSON();
    dispatch(
      setUpdatedCanvas({
        canvasIndex: _currentSlide,
        data: updatedCanvasData,
      })
    );
    dispatch(copySlide());
  };
  const handlePageThumbnailClick = (i) => {
    const updatedCanvasData = canvas.toDatalessJSON();
    canvas.setBackgroundImage(null);
    dispatch(
      setUpdatedCanvas({
        canvasIndex: _currentSlide,
        data: updatedCanvasData,
      })
    );
    dispatch(setCurrentSlide(i));
    dispatch(setCurrentCanvas(i));
  };
  return (
    <>
      <div
        className="w-full fixed bottom-2 flex p-1 bg-transparent flex-row justify-center items-center mb-2"
        style={{ marginBottom: "40px" }}
      >
        {isDrawingMode && (
          <div
            className="bg-red-300 p-3 mb-4 text-gray-700 text-lg shadow-2xl z-10 font-bold rounded w-[auto] h-[50px] mr-2 cursor-pointer"
            onClick={() => {
              canvas.isDrawingMode = false;
              dispatch(setIsDrawingMode(false));
            }}
          >
            Exit Drawing
          </div>
        )}
        <div className=" bg-white p-3 mb-4 rounded-lg w-auto shadow-2xl z-10 flex items-center">
          <div id="hoverarea" className="flex items-end gap-x-4">
            {_Canvases.map((page, i) => {
              return (
                <button
                  className={`bg-red-50 text-gray-700 text-2xl font-bold rounded w-[50px] h-[50px] ${
                    _currentSlide === i ? "border-2 border-blue-500" : ""
                  }`}
                  onClick={() => {
                    handlePageThumbnailClick(i);
                  }}
                  key={i}
                >
                  {i + 1}
                </button>
              );
            })}
          </div>
          <div>
            <div className="flex flex-col">
              <Tooltip
                title="Add blank page"
                placement="right"
                arrowPointAtCenter
              >
                <button
                  className="bg-blue-500 text-white text-xl font-bold rounded ml-4 flex justify-center items-center mb-1"
                  style={{ width: "50px", height: "25px" }}
                  onClick={handlePlusIconClick}
                >
                  <BsPlus />
                </button>
              </Tooltip>
              <Tooltip
                title="Duplicate this page"
                placement="right"
                arrowPointAtCenter
              >
                <button
                  className="bg-green-500 text-white text-xl font-bold rounded ml-4 flex justify-center items-center mt-1"
                  style={{ width: "50px", height: "25px" }}
                  onClick={handleCopyIconClick}
                >
                  <BiCopy />
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Slidebar;
